import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOnHandEntry } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const GetOnHandDetailsAPI = async (osdNumber: number | string): Promise<IOnHandEntry> => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.ON_HAND_VIEW);
    // Add dynamic OSD-Exception-Number
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber?.toString(),
    };
    const response = await axios.get(`${getUrl(ApiType.ON_HAND_VIEW)}/${osdNumber}`, { headers });
    return response?.data ?? {};
  } catch (error) {
    return throwApiError(error, ErrorMessages.aSEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
  }
};
